import { useJackpotBar } from '@hooks/jackpot/useJackpotBar'

// Pure render — ports defenderV2's header JackpotBar (gold progress track,
// text fades between "Jackpot" and the live fill percentage every 5s). Only
// rendered while an active jackpot exists (useActiveJackpot, shared with the
// main-layout ratio message and the menu's Active tab).
const JackpotBarModule = () => {
  const { isVisible, showText, fillPercentage, animationKey, onOpen } = useJackpotBar()

  if (!isVisible) return null

  return (
    <div className="standard-normal-jackpot-bar-module-container" onClick={onOpen}>
      <div className="standard-normal-jackpot-bar-track">
        <div className="standard-normal-jackpot-bar-fill" style={{ width: `${fillPercentage}%` }} />
        <div
          key={animationKey}
          className="standard-normal-jackpot-bar-text"
          style={{ '--jackpot-bar-fill-width': `${fillPercentage}%` }}
        >
          {showText ? 'Jackpot' : `${fillPercentage.toFixed(2)}%`}
        </div>
      </div>
    </div>
  )
}

export default JackpotBarModule
